import * as t from './actionTypes';
import { fetchSenders, fetchSendersResponse, fetchSendersError } from './actions';
import type { SendersReducerState } from './types';

export const initialState: SendersReducerState['settings']['senders'] = {
  isFetchingSenders: false,
  smsSenders: [],
  authedEmails: [],
  smsMessageTypes: [],
  smsEsps: [],
  validSendDomains: [],
};

type SendersAction =
  | ReturnType<typeof fetchSenders>
  | ReturnType<typeof fetchSendersResponse>
  | ReturnType<typeof fetchSendersError>;

export const sendersReducer = (state = initialState, action: SendersAction) => {
  switch (action.type) {
    case t.FETCH_SENDERS_REQUEST:
    case t.FETCH_SENDERS_ERROR:
      return {
        ...state,
        isFetchingSenders: true,
      };
    case t.FETCH_SENDERS_RESPONSE:
      return {
        isFetchingSenders: false,
        smsSenders: action.smsSenders,
        authedEmails: action.authedEmails,
        smsMessageTypes: action.smsMessageTypes,
        smsEsps: action.smsEsps,
        validSendDomains: action.validSendDomains,
      };
    default:
      return state;
  }
};
